import { carriers } from '~domain/i18n/english/carriers';
import { policies } from '~domain/i18n/english/policies';
import { ProductType } from '~domain/model/core/product-type';

export const english = {
  common: {
    amfLicensed:
      'YouSet Insurance is a brokerage firm in damage insurance registered with the AMF. We compare for you the prices of many insurers like Intact, Economical, L’Unique and others. The complete list is available on our website.',
    copyright: '©YOUSET INSURANCE TECHNOLOGIES {{0}} ALL RIGHTS RESERVED',
  },
  productTypes: {
    home: 'Home',
    car: 'Car',
  } satisfies Record<ProductType, string>,
  carriers,
  policies,
};

export type BaseTranslationKeys = typeof english;
